import { computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useRouteParams } from "@vueuse/router";
import { useExperienceRawApi } from "@/composables/useExperienceRawApi";
import type { Snapshot } from "@/types/Snapshots";

export const TRANSLATION_DIFF_SNAPSHOTS_QUERY_KEY = "translation-diff-snapshots";

export interface TranslationDiffSnapshotsData {
  snapshot: Snapshot | undefined;
  secondLastSnapshot: Snapshot | undefined;
}

export function useCurrentTranslationDiffSnapshotsQuery() {
  const experienceId = useRouteParams<string>("id");
  const experienceRawApi = useExperienceRawApi();

  return useQuery({
    queryKey: [TRANSLATION_DIFF_SNAPSHOTS_QUERY_KEY, experienceId],
    queryFn: async (): Promise<TranslationDiffSnapshotsData> => {
      const { data } = await experienceRawApi.getLastTwoSnapshots(experienceId.value);

      return {
        snapshot: data[0],
        secondLastSnapshot: data[1],
      };
    },
    enabled: computed(() => !!experienceId.value),
  });
}
